import React from 'react';

import { CardPlaceholder } from 'app/components/domain/card-placeholder';
import { OrderDetailsPlaceholder } from 'app/components/domain/order-details/order-details-placeholder';
import { Typography } from 'app/components/domain/typography';
import { i18n } from 'app/i18n';

import styles from './summary-placeholder.module.scss';

export const SummaryPlaceholder = () => (
    <div>
        <CardPlaceholder descriptionCount={5} />
        <CardPlaceholder descriptionCount={3} className={styles.card} />
        <Typography variant="subtitle1" component="h2">
            {i18n.summary.productDetails.selectedProducts}
        </Typography>
        <OrderDetailsPlaceholder />
    </div>
);
